import type { TransformStep } from './types';

export const stubStep: TransformStep = (nodes, context) => {
	return nodes;
};
